import { Navigate } from "react-router-dom";
import PageLoader from "@components/Loader/Loader";
import { useAuthContext } from "state/context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const {
    state: { isAuthenticated, status },
  } = useAuthContext();

  if (status === "loading") {
    return <PageLoader />;
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
